import React, { useState } from 'react';
import { Alert, Form, Select, Spin } from 'antd';
import { useOrganizationUsers } from './hook';
import { useCurrentOrganization } from 'hooks/useCurrentOrganization';

const Option = Select.Option;

export interface SelectedOption {
  id: string;
  fullName: string;
}

interface OrganizationUserDropdownProps {
  name: string;
  label?: string;
  value?: SelectedOption;
  onChange?: (item: { [name: string]: SelectedOption }) => void;
  hideAll?: boolean;
  hidden?: boolean;
  required?: boolean;
  inputOnly?: boolean;
  disabled?: boolean;
}

export function OrganizationUserDropdown(props: OrganizationUserDropdownProps) {
  const [value, setValue] = useState<string | undefined>(props.value?.id);
  const currentOrganization = useCurrentOrganization();

  const { loading, error, data } = useOrganizationUsers({ idOrganization: currentOrganization.id });

  const LABEL = props.label ?? 'User';
  const ALL_OPTION = { id: '-1', fullName: `All ${LABEL.toLowerCase()}s` };

  const handleChange = (value: string) => {
    setValue(value);
    if (props.onChange) {
      const obj = data?.find((i) => i.id === value);
      const newValue = { [props.name]: obj ?? ALL_OPTION };
      props.onChange(newValue);
    }
  };

  const renderOptions = () => {
    if (loading) {
      if (props.value?.id) {
        return [
          <Option key={props.value.id} value={props.value.id}>
            {props.value.fullName}
          </Option>,
        ];
      } else if (props.hideAll) {
        return [];
      }
    }

    const options = [];

    if (!props.hideAll) {
      options.push(ALL_OPTION);
    }

    if (data) {
      data.forEach((i) => options.push(i));
    }

    return options.map((i) => (
      <Option key={i.id} value={i.id}>
        {i.fullName}
      </Option>
    ));
  };

  const renderEmptyOrNotFoundContent = () => {
    if (loading) {
      return <Spin size="small" />;
    }
    if (error) {
      return <Alert showIcon={true} style={{ width: '100%' }} message={error} type="error" />;
    }
    return null;
  };

  const render = (select: React.ReactElement) => {
    if (props.inputOnly) {
      return select;
    }
    return (
      <Form.Item name={props.name} label={LABEL} hidden={props.hidden} rules={[{ required: props.required, message: `${LABEL} is required` }]}>
        {select}
      </Form.Item>
    );
  };

  return render(
    <Select style={{ width: '100%' }} disabled={props.disabled} value={value} placeholder="Select user" onChange={handleChange} loading={loading} notFoundContent={renderEmptyOrNotFoundContent()}>
      {renderOptions()}
    </Select>,
  );
}
